"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPaymentsCollectedEntryResponeList = exports.transformPaymentsCollectedEntryRespone = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Money_1 = require("../Money");
function transformPaymentsCollectedEntryRespone(response) {
    return {
        amount: response.amount && (0, Money_1.transformMoneyParsedResponse)(response.amount),
        client: response.client,
        clientId: response.clientid,
        creditNumber: response.credit_number,
        creditId: response.creditid,
        date: response.date,
        description: response.description,
        fromCredit: response.from_credit,
        invoiceNumber: response.invoice_number,
        invoiceId: response.invoiceid,
        method: response.method,
    };
}
exports.transformPaymentsCollectedEntryRespone = transformPaymentsCollectedEntryRespone;
function transformPaymentsCollectedEntryResponeList(data) {
    if (data && data.length > 0) {
        return data.map((child) => transformPaymentsCollectedEntryRespone(child));
    }
    else {
        return [];
    }
}
exports.transformPaymentsCollectedEntryResponeList = transformPaymentsCollectedEntryResponeList;
//# sourceMappingURL=PaymentsCollectedEntry.js.map